// extracted by mini-css-extract-plugin
module.exports = {"clients":"styles_clients__SdKRM","listWrapper":"styles_listWrapper__3QLSj","list":"styles_list__k2VNa","scroll":"styles_scroll__3ViUN","listItems":"styles_listItems__3RIXA"};